import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useCancellationProtectionConfig() {
  return useCbhFlag(CbhFeatureFlag.RELEASE_CANCELLATION_PROTECTION, {
    defaultValue: { enabled: false },
  });
}
